import {StyleSheet} from 'react-native';

const styles = {
  checkmark: {
    position: 'relative',
    borderRadius: 90,
    borderWidth: 3,
    borderColor: '#992929',
    width: 150,
    height: 150,
  },
  vector1: {
    top: 70,
    left: 34,
    height: 3,
    width: 73,
    transform: [{rotate: '-135deg'}],
    backgroundColor: '#992929',
  },
  vector2: {
    top: 67,
    left: 35,
    height: 3,
    width: 73,
    transform: [{rotate: '-45deg'}],
    backgroundColor: '#992929',
  },
};

export default StyleSheet.create(styles);
